(ns frontend.view.curtains.webentry-resolution.components.attachments
  (:require
   [common.dates :as d :include-macros true]
   [common.localization :as loc]
   [frontend.utils :as utils]
   [frontend.bootstrap.components :as rbs]))

(defn long->formatted-date
  [ms]
  (-> ms
      js/Date.
      (d/format {:pattern (loc/tr :attachment/date-format)})))

(defn attachment-view
  [{:keys [attachment]}]
  (when-not (empty? attachment)
    (let [{:keys [attachment/filename attachment/uploader attachment/created]} attachment]
      [rbs/ListGroupItem
       {:class "deal-attachments-list-attachment"}
       [:div.deal-attachments-list-attachment-right
        (when-not (or (nil? created) (zero? created))
          [:span.deal-attachments-list-attachment__created
           (long->formatted-date created)])]
       [:div.deal-attachments-list-attachment-left
        {:on-click #(utils/open-attachment! (:db/id attachment))}
        [:i.fal.fa-paperclip.deal-attachments-list-attachment__icon]
        [:span.deal-attachments-list-attachment__filename filename]]])))
